export const v64 = {
    default: "#EA6206",
    subtle: "#F98314",
    strong: "#DB4E00",
};
